export default __webpack_public_path__ + "static/media/page9Image1.18b3b07e.jpg";